import React from 'react';
import { css } from '@emotion/react';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';
import styled from 'types/theme.types';
import { SwitcherContainer } from 'components/layout/topbar/switcher/switcher-container';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import useStores from 'hooks/use-stores.hooks';
import { FeatureFlag } from 'constants/feature-flags';
import { useFeatureFlag } from 'hooks/use-feature-flags';

const UserSwitcher: React.FunctionComponent = () => {
  const { authStore } = useStores();
  const isDesignSwitchAvailable = useFeatureFlag(FeatureFlag.UI_POLISH_NEW_DESIGN);
  return (
    <SwitcherContainer>
      <Link to="/personal-settings">
        <MenuItem>
          <FormattedMessage id="personal.settings.menu.personal-settings" />
        </MenuItem>
      </Link>
      {isDesignSwitchAvailable && (
        <Link to="/personal-settings/appearance">
          <MenuItem data-e2e="appearance-link">
            <FormattedMessage id="personal.settings.menu.appearance" />
          </MenuItem>
        </Link>
      )}
      <MenuItem onClick={() => authStore.logout()} data-e2e="logout-link">
        <FormattedMessage id="navigation.logout" />
      </MenuItem>
    </SwitcherContainer>
  );
};

const MenuItem = styled.div`
  cursor: pointer;
  padding: 14px 18px;
  font-size: 13px;
  display: flex;
  align-items: center;
  ${legacyOnly(
    theme => css`
      color: ${theme.primaryBlack} !important;
      background: ${theme.primaryWhite};
    `
  )}
  ${newDesignOnly(css`
    color: var(--text-heading);
    background: var(--surface-main-cards);
  `)}

  &:hover {
    ${legacyOnly(
      theme => css`
        background: ${theme.menuGray};
      `
    )}
    ${newDesignOnly(css`
      background: var(--surface-main-element-on-card);
    `)}
  }
`;

export default UserSwitcher;
